/*
  The selectable theme fonts are duplicated in ruby
  Dont forget to update it as well: app/services/theme_service/font_families.rb

  Every entry needs its @fontsource-variable package imported in
  app/javascript/layout/tailwind.css
 */
export type FontFamily = {
  key: string;
  label: string;
  cssFamily: string;
};

export const DEFAULT_FONT_FAMILY = "inter";

export const FONT_FAMILIES: FontFamily[] = [
  { key: "inter", label: "Inter", cssFamily: "Inter Variable" },
  { key: "outfit", label: "Outfit", cssFamily: "Outfit Variable" },
  { key: "roboto", label: "Roboto", cssFamily: "Roboto Variable" },
  { key: "dm-sans", label: "DM Sans", cssFamily: "DM Sans Variable" },
  {
    key: "plus-jakarta-sans",
    label: "Plus Jakarta Sans",
    cssFamily: "Plus Jakarta Sans Variable",
  },
  { key: "manrope", label: "Manrope", cssFamily: "Manrope Variable" },
  {
    key: "public-sans",
    label: "Public Sans",
    cssFamily: "Public Sans Variable",
  },
  {
    key: "space-grotesk",
    label: "Space Grotesk",
    cssFamily: "Space Grotesk Variable",
  },
];

export function fontFamilyCss(key: string | null | undefined): string | null {
  if (!key) return null;
  return FONT_FAMILIES.find((font) => font.key === key)?.cssFamily || null;
}
